module.exports = __webpack_public_path__ + "static/img/image2.3e0a314d.png";